"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounce = void 0;
const react_1 = __importDefault(require("react"));
const is_defined_1 = require("../is-defined");
const useDebounce = ({ onChange, ms, value, }) => {
    const timeoutId = react_1.default.useRef(undefined);
    const prevValue = react_1.default.useRef(value);
    const [debouncedValue, setDebouncedValue] = react_1.default.useState(value);
    const DEBOUNCE_MS = react_1.default.useMemo(() => ms ?? 0, [ms]);
    react_1.default.useEffect(() => {
        // other dependencies changed
        if (debouncedValue === prevValue.current) {
            return;
        }
        prevValue.current = debouncedValue;
        // do not clear this in return
        // -> on component dismount the final timeout will be cleared as well
        if ((0, is_defined_1.isValue)(timeoutId)) {
            clearTimeout(timeoutId.current);
        }
        timeoutId.current = setTimeout(() => {
            onChange(debouncedValue);
        }, DEBOUNCE_MS);
    }, [debouncedValue, onChange, DEBOUNCE_MS]);
    return {
        value: debouncedValue,
        onChange: setDebouncedValue,
    };
};
exports.useDebounce = useDebounce;
